// src/App.js
import { is } from '@babel/types';
import React, { Component, Suspense, lazy, createContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { isMobile } from './scripts/cds';
import {Coupon} from './pages/components/Coupon';
import FunctionContext from './contexts/FunctionContext';
import emitter from './scripts/eventEmitter';
import { trans, changeLanguage, setLanguage } from './scripts/translate';

if (isMobile()) {
    import('./css/mobile.css');
} else {
    import('./css/login.css');
}

const AuthContext = createContext();

// Bileşenleri lazy yükleme
const Home = lazy(() => import('./pages/Home'));
const Login = lazy(() => import('./pages/Login'));
const Header = lazy(() => import('./pages/Header'));
const Live = lazy(() => import('./pages/Live'));
const Favorites = lazy(() => import('./pages/Favorites'));
const UserCoupons = lazy(() => import('./pages/UserCoupons'));
const ProfileWrapper = lazy(() => import('./pages/account/ProfileWrapper'));
const Casino = lazy(() => import('./pages/Casino'));
const Virtuals = lazy(() => import('./pages/Virtuals'));

// mobil bileşenleri lazy yükleme
const MobileHeader = lazy(() => import('./pages/mobile/Header'));

export class App extends Component {

    state = {
        loaded: false,
        isLoggedIn: false,
        user: false,
        errorMessage: null,
        successMessage: null
    };

    componentDidMount() {

        // device detect
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
            // url'den www sil
            var url = window.location.href;
            if (!url.includes('localhost')) {
                if (url.includes('://www.')) {
                    url = url.replace('www.', '');
                }
                url = url.replace('https://', 'https://m.');
                // masaüstü siteye yönlendir
                window.location.href = url;
            }
        }

        const token = localStorage.getItem('token');
        
        if (token) {
            fetch(process.env.REACT_APP_API_URL + '/userinfo', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then(response => response.json())
            .then(json => {
                if (json.status == 'error') {
                    this.setState({ 
                        isLoggedIn: false,
                        loaded: true
                    });
                } else {
                    this.setState({ 
                        isLoggedIn: true,
                        user: json.user,
                        loaded: true
                    });
                    setLanguage(json.user.lang);
                    window.localStorage.setItem('lang', json.user.lang);
                    document.title = json.settings.site_title;
                }
            });
        } else {
            setTimeout(() => {
                this.setState({ loaded: true });
            }, 100);
        }

        emitter.on('error', (error) => {
            this.setState({
                errorMessage: error
            });
            setTimeout(() => {
                this.setState({ errorMessage: null });
            }, 5000);
        });

        emitter.on('success', (success) => {
            this.setState({
                successMessage: success
            });
            setTimeout(() => {
                this.setState({ successMessage: null });
            }, 5000);
        });

    }

    render() {

        if (!this.state.loaded) {
            return <div className="flex max-w-[1920] min-w-[1460px] scroll-smooth bg-secondary-300 dark:bg-secondary-dark-300">
                <div className="flex flex-col w-full" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="flex bg-primary fixed p-3 rounded animate-pulse">
                        <img className="w-full" alt="logo" src={process.env.PUBLIC_URL + '/logo.png'} />
                    </div>
                </div>
            </div>
        }

        if (!this.state.isLoggedIn) {
            return <Login />;
        }

        return (
            <Router>
                <div className="flex max-w-[1920] min-w-[1460px] scroll-smooth bg-secondary-300 dark:bg-secondary-dark-300">

                    {this.state.errorMessage &&
                        <div className="flex flex-col fixed top-0 right-0 p-4 z-200 w-screen max-w-[400px]">
                            <div className="flex flex-col p-3 mb-2 text-gray-500 rounded-lg drop-shadow-xl backdrop-blur-lg backdrop-grayscale bg-slate-9/70" role="alert">
                                <div className="flex items-center">
                                    <div className="inline-flex flex-shrink-0 justify-center items-center w-8 h-8 rounded-lg text-xl bg-red-500">
                                        <div className="i-tabler-x text-white"></div>
                                    </div>
                                    <p className="ml-3 mb-0 text-md font-normal text-white">{this.state.errorMessage}</p>
                                </div>
                            </div>
                        </div>
                    }
                    {this.state.successMessage &&
                        <div className="flex flex-col fixed top-0 right-0 p-4 z-200 w-screen max-w-[400px]">
                            <div className="flex flex-col p-3 mb-2 text-gray-500 rounded-lg drop-shadow-xl backdrop-blur-lg backdrop-grayscale bg-slate-9/70" role="alert">
                                <div className="flex items-center">
                                    <div className="inline-flex flex-shrink-0 justify-center items-center w-8 h-8 rounded-lg text-xl bg-green-500">
                                        <div className="i-tabler-check text-white"></div>
                                    </div>
                                    <p className="ml-3 mb-0 text-md font-normal text-white">{this.state.successMessage}</p>
                                </div>
                            </div>
                        </div>
                    }  

                    <div className="flex flex-col w-full">
                        <Header user={this.state.user}></Header>

                        <Suspense fallback={<div></div>}>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/today-matches" element={<Home stage="today" />} />
                                <Route path="/login" element={<Login isLoggedIn={this.state.isLoggedIn} />} />
                                <Route path="/live-bet" element={<Live />} />
                                <Route path="/top-combis" element={<Home stage="top-combis" />} />
                                <Route path="/results/:leagueid" element={<Home stage="results" />} />
                                <Route path="/my-favorites" element={<Favorites />} />
                                <Route path="/live-casino" element={<Casino lobby="live" />} />
                                <Route path="/casino" element={<Casino lobby="slot" />} />
                                <Route path="/account/tickets" element={<UserCoupons />} />
                                <Route path="/account/:page" element={<ProfileWrapper user={this.state.user}></ProfileWrapper>} />
                                <Route path="/virtuals" element={<Virtuals />} />
                                <Route path="/virtuals/:sportid" element={<Virtuals />} />
                            </Routes>
                        </Suspense>

                        <section className="block">
                            <div className="flex justify-center bg-gray-4">
                                <div className="flex flex-col min-w-[1185px] max-w-[1185px] px-4">
                                    <div className="flex w-full items-center border-b-2 py-8">
                                        <div className="w-3/4 text-xs text-gray-500">{trans('footer_text')}</div>
                                        <div className="flex w-1/4 justify-end">
                                            <select value={this.state.user.lang} onChange={(e) => changeLanguage(e.target.value)} className="w-56 h-10 bg-gray-4 border border-gray-300 text-gray-900 text-base rounded-md focus:ring-blue-500 focus:border-blue-500 focus:ring-0 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                <option value="tr">Türkçe</option>
                                                <option value="en">English</option>
                                                <option value="de">German</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="flex w-full justify-between border-b-2 py-2">
                                        <div className="flex w-full justify-between">
                                            <div className="flex w-1/2 justify-start items-center cursor-pointer py-4">
                                                <div className="flex items-center justify-center w-9 h-9 bg-stone-400 border-3 border-gray-600 rounded-full text-gray600 font-semibold hover:bg-red-700 text-white">18+</div>
                                                <div className="footer-warn-1 px-2 text-1xs text-gray-600">{trans('Sorumlu Oyun')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="flex flex-col items-center fixed left-5 bottom-5 z-89">
                            <div className="flex drop-shadow-md items-center justify-center w-11 h-11 bg-primary bg-opacity-60 rounded-full hover:bg-opacity-100 cursor-pointer transition-all ease-in-out">
                                <div className="w-8 h-8 bg-secondary-100 dark:bg-secondary-dark-100 i-tabler-chevron-up"></div>
                            </div>
                        </div>

                    </div>
                </div>
            </Router>
        );
    }
}

export default App;
